import {createConfirmation} from 'react-confirm';
import AlertDialog from 'components/pure/utils/AlertDialog';

const alert = createConfirmation(AlertDialog);

export default (confirmation, title, options = {}) => {
  return alert({confirmation, options, title});
};
